'use client';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
	ClaropaySDKApi,
	ICardClaroPay,
	IProcessPayment,
	IUserConfirmation,
	IUserPasswordLess,
} from '@claropay/web-portal-sdk';
import * as claropaywebsdk from '@claropay/web-portal-sdk'

let claropaywebportalsdk: ClaropaySDKApi;

export const useClaropaySdk = () => {


	const initialize = (bundleId: string, bundleVersion) => {
		 const isContainer =
       process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS && process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS.includes(bundleId) || false;

		const tokenizationConfig = JSON.parse(
			window.atob(
				process.env.REACT_APP_SDK_TOKENIZATION_DEFAULT
					? process.env.REACT_APP_SDK_TOKENIZATION_DEFAULT
					: "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",
			),
		);
		const defaultTokenization =
			bundleVersion && tokenizationConfig[bundleVersion]
				? tokenizationConfig[bundleVersion]
				: tokenizationConfig["default"];
		claropaywebportalsdk = new claropaywebsdk.ClaropaySDKApi(
			`${process.env.REACT_APP_SDK_API_KEY}`,
			(resourceInformation: any, errorInitialize: any) => {
				console.log("*** WEB SDK Launch ***")
				// claropaywebportalsdk.setState("minimalAppSync", "", () => {}, () => {});
			},
			{
				bundleVersion: bundleVersion,
				countryId: `${process.env.REACT_APP_APPSYNC_COUNTRY_ID}`,
				bundleId:
					bundleId && bundleId !== null
						? bundleId
						: `${process.env.REACT_APP_CLARO_PAY_BUNDLE_VERSION_DEFAULT}`,
				apiKey: process.env.REACT_APP_SDK_API_KEY
					? process.env.REACT_APP_SDK_API_KEY
					: '',
				claroID: process.env.REACT_APP_SDK_CLARO_ID,
				apiKeyClaroID: process.env.REACT_APP_SDK_API_KEY_CLARO_ID,
				passwordLess: process.env.REACT_APP_SDK_API_PASSWORDLESS,
				apiKeyPasswordLess: process.env.REACT_APP_SDK_API_KEY_PASSWORDLESS,
				appsync: process.env.REACT_APP_SDK_API_APPSYNC,
				apiKeyAppsync: process.env.REACT_APP_SDK_API_KEY_APPSYNC,
				calculadoraComisiones:
					process.env.REACT_APP_SDK_API_CALCULADORA_COMISIONES,
				apiKeyCalculadoraComisiones:
					process.env.REACT_APP_SDK_API_KEY_CALCULADORA_COMISIONES,
				cardManagement: process.env.REACT_APP_SDK_API_CARD_MANAGEMENT,
				apiKeyCardManagement:
					process.env.REACT_APP_SDK_API_KEY_CARD_MANAGEMENT,
				proxyService: process.env.REACT_APP_SDK_API_PROXY_SERVICE,
				apiKeyProxyService: process.env.REACT_APP_SDK_API_KEY_PROXY_SERVICE,
				binesCatalog: process.env.REACT_APP_SDK_BINES_CATALOG,
				messagingCatalog: process.env.REACT_APP_SDK_MESSAGING_CATALOG,
				apiKeyMessagingCatalog:
					process.env.REACT_APP_SDK_API_KEY_MESSAGING_CATALOG,
				appVersion: process.env.REACT_APP_SDK_APP_VERSION,
				payment: process.env.REACT_APP_SDK_API_PAYMENT,
				apikeyPayment: process.env.REACT_APP_SDK_API_KEY_PAYMENT,
				processKey: window.atob(
					process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						? process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						: '4a$NGEkc1dvcjBs',
				),
				checkPayment: process.env.REACT_APP_SDK_CHECK_PAYMENT,
				apiKeycheckPayment: process.env.REACT_APP_SDK_API_KEY_CHECK_PAYMENT,
				validateAccountNumber: process.env.REACT_APP_VALIDATE_ACCOUNT_NUMBER,
				apiKeyValidateAccountNumber: process.env.REACT_APP_KEY_VALIDATE_ACCOUNT_NUMBER,
				createCard: isContainer? process.env.REACT_APP_CREATE_CARD : process.env.REACT_APP_CREATE_CARD,
				apiKeyCreateCard: process.env.REACT_APP_KEY_CREATE_CARD,
				deleteCard: process.env.REACT_APP_DELETE_CARD,
				apiKeyDeleteCard: process.env.REACT_APP_KEY_DELETE_CARD,

				tokenizationCardMicrofront: process.env.REACT_APP_SDK_TOKENIZATION_APP_ID,
				useProxySessionTags: false,
				useProxyAppSync: true,
				useProxySearchCard:
					`${process.env.REACT_APP_SDK_API_SEARCH_CARD_USE_PROXY}` === "true",

				searchCard: process.env.REACT_APP_SDK_API_SEARCH_CARD,
				apiKeySearchCard: process.env.REACT_APP_SDK_API_KEY_SEARCH_CARD,
				webProxyServer: process.env.REACT_APP_SERVICE_PROXY_SERVER,
				apiKeyWebProxyServer: process.env.REACT_APP_SERVICE_PROXY_SERVER_API_KEY,

				appByKey: process.env.REACT_APP_SERVICE_APP_BY_KEY,
				apiKeyAppByKey: process.env.REACT_APP_SERVICE_APP_BY_KEY_API_KEY,

				defaultTokenization: defaultTokenization,
				minimalAppSync: process.env.REACT_APP_SDK_API_MINIMAL_APP_SYNC,
				apiKeyMinimalAppSync: process.env.REACT_APP_SDK_API_KEY_MINIMAL_APP_SYNC,


        		timeoutWebProxyServerForVesta: 3000,
				
				profile: process.env.REACT_APP_SERVICE_PROFILE_CACHED,
				apiKeyProfile: process.env.REACT_APP_SERVICE_PROFILE_CACHED_API_KEY,
				tokenizationCardMicrofrontUrl: `${process.env.REACT_APP_URL_MICROAPP_TOKENIZATION_CARD}`,
				isUrlTokenizationCardMicrofront: true,
			},
		);
	};

	const wrapperObservable = (pusblish: any) => {
		console.debug('wrapperObservable');
		return from(pusblish).pipe(
			map((x: any) => {
				return JSON.parse(x);
			}),
			catchError((error) => {
				return of({
					success: false,
					data: {
						error: error.toString(),
					},
				}).pipe((x) => x);
			}),
		);
	};

	const setState = (id: string, state: any) => {
		console.debug(`id ${id}, state ${state}`);
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.setState(
					id,
					state,
					(result: any) => {
						console.log('Set State success');
						resolve(result);
					},
					(error: any) => {
						console.log('Set State error');
						reject(error);
					}
				)
			} catch (error) {
				console.log('Set State catch');
				reject(error);
			}
		})
	};

	const getState = (id: string) => {
		console.debug(`id ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getState(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const userExist = (id: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.userExist(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const createUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(
			`userPasswordLess, IUserPasswordLess ${JSON.stringify(userPasswordLess)}`,
		);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   success: true,
		//   data: {
		//     msisdn: '+528126275000',
		//     username: '3b54ad9d-c578-447c-910b-09a9273ae624',
		//     session: '48b0a50a-ac8a-4f1e-ae31-efee21f11a7d',
		//     secondsForNewRequest: 30,
		//     countOTPs: 1,
		//     creationDate: 1693947953874,
		//     tokenOperation: '83c24a85e3822fa21a0909c070ad1abc',
		//   },
		// }).pipe((x: any) => x);
	};

	const confirmationCodeNewUserPasswordLess = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.confirmationCodeNewUserPasswordLess(
				user,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   access_token: 'eyJraWQiOiJ2WU5XcFlBcTJ4ZStrREdTRDZ5TjMxO...',
		//   expires_in: 3600,
		//   id_token: 'eyJraWQiOiI2VHM3OERi...',
		//   refresh_token: 'eyJjdHkiOiJKV1QiL...',
		//   token_type: 'Bearer',
		//   tokenOperation: 'af0deeb...',
		// }).pipe((x: any) => x);
	};

	const resendCodeUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(`userPasswordLess ${JSON.stringify(userPasswordLess)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.resendCodeUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const initTokenUserPasswordLess = (phone: string) => {
		console.debug(`phone, string ${phone}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.initTokenUserPasswordLess(phone, "SMS", resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const generateTokenUserPasswordLess = (
		msisdn: string,
		code: string,
		session: string,
	) => {
		console.debug(`msisdn, string ${msisdn}`);
		console.debug(`code, string ${code}`);
		console.debug(`session, string ${session}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.generateTokenUserPasswordLess(
				msisdn,
				code,
				session,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const getToken = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getToken(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const createUserTemporal = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserTemporal(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const permanentUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.permanentUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const deleteUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.deleteUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const logout = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.logout(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const trustUser = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.trustUser(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getProfile = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getProfile(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const appSync = (
		countryId: string,
		bundleID: string,
		bundleVersion: string,
		bankId: string,
	) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.appSync(
					countryId,
					bundleID,
					bundleVersion,
					bankId,
					(result: any) => {
						console.log("AppSync success");
						resolve(result);
					},
					(error: any) => {
						console.log("AppSync error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("AppSync catch");
				reject(error);
			}
		})
	};

	const searchCard = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.searchCard(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const saveCard = (card: ICardClaroPay) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.saveCard(
					card,
					(result: any) => {
						console.log("Save card success");
						resolve(result);
					},
					(error: any) => {
						console.log("Save card error");
						reject(error);
					},
					true,
				);
			} catch (error) {
				console.log("Save card catch");
				reject(error);
			}
		});
	};
	const openTokenizationCard = (
		idContainer: string,
		configuration: claropaywebsdk.ITokenizationConfig,
		onEvent: any,
		claropaySDKMobileApiInstance: any
	) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.openTokenizationCard(
					idContainer,
					configuration,
					onEvent,
					claropaySDKMobileApiInstance,
					(result: any) => {
						console.debug("Save card success");
						resolve(result);
					},
					(error: any) => {
						console.debug("Save card error");
						reject(error);
					}
				);
			} catch (error) {
				console.debug("Save card catch");
				reject(error);
			}
		});
	};

	const processPayment = (
		payment: IProcessPayment,
		geo: claropaywebsdk.IGeolocalization
	) => {
		console.log('hook');
		console.log(payment);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.processPayment(
				payment,
				geo,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const calculateCommission = (
		serviceId: string,
		merchantId: string,
		amount: string,
		isClaroPay: string,
		cardId: string,
		appVersion: string,
		isClaroPartner: string,
	) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.calculateCommission(
				serviceId,
				merchantId,
				amount,
				isClaroPay,
				cardId,
				appVersion,
				isClaroPartner,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const downloadBinesCatalog = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadBinesCatalog(resolve, reject);
		});
		// return wrapperObservable(publish);
	};

	const downloadMessaggingClaropay = (bundleId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadMessaggingClaropay(bundleId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getMessaggingClaropay = (flux: string, code: string, bundleId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getMessaggingClaropay(flux, code, bundleId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const setToken = (isTemporalUser: boolean, token: any) => {
		console.debug("isTemporalUser, ", isTemporalUser);
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.setToken(
					token,
					(result: any) => {
						console.log("Set token success")
						resolve(result);
					},
					(error: any) => {
						console.log("Set token error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("Set token catch");
				reject(error);
			}
		});
	};

	const getBin = (bin: string) => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getBin(bin, resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const termsConditions = (msisdn: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.termsConditions(msisdn, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const checkPayment = (authorizationId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.checkPayment(authorizationId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getBinInline = (bin: string) => {
		return claropaywebportalsdk.getBinInline(bin);
	};

	const sendOTP = (id: string, mail: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.sendOTP(id, mail, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const validateOTP = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.validateOTP(user, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const isCardCustomer = (claroid: string) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.isCardCustomer(
					claroid,
					(result: any) => {
						resolve(result);
					},
					(error: any) => {
						reject(error);
					}
				);
			} catch (error) {
				reject(error);
			}
		});
	}

	return {
		initialize,
		setState,
		getState,
		userExist,
		createUserPasswordLess,
		confirmationCodeNewUserPasswordLess,
		resendCodeUserPasswordLess,
		initTokenUserPasswordLess,
		generateTokenUserPasswordLess,
		getToken,
		createUserTemporal,
		permanentUser,
		deleteUser,
		logout,
		getProfile,
		trustUser,
		appSync,
		searchCard,
		saveCard,
		openTokenizationCard,
		processPayment,
		calculateCommission,
		downloadBinesCatalog,
		downloadMessaggingClaropay,
		getMessaggingClaropay,
		setToken,
		getBin,
		getBinInline,
		termsConditions,
		checkPayment,
		sendOTP,
		validateOTP,
		isCardCustomer
	};
};

